import React from 'react';
import { motion } from 'framer-motion';
export function AboutMe() {
  return <section className="w-full py-24 px-4 bg-[#111]" data-id="element-31">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="w-40 h-40 sm:w-48 sm:h-48 rounded-full overflow-hidden border-4 border-[#D4AF37]/30 mb-8 shadow-2xl" data-id="element-33">
          <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=600&q=80" alt="Ludmila Reyes" className="w-full h-full object-cover" data-id="element-34" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} data-id="element-35">
          <h2 className="font-playfair text-3xl sm:text-4xl text-white mb-2" data-id="element-36">
            Ludmila Reyes 🌸
          </h2>
          <p className="font-inter text-[#D4AF37] text-sm sm:text-base uppercase tracking-widest mb-8 font-semibold" data-id="element-37">
            Sanadora Espiritual & Guía Energética
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-12 text-sm font-inter text-gray-400" data-id="element-38">
          <span className="flex items-center gap-2" data-id="element-39">🔮 +10 Años</span>
          <span className="flex items-center gap-2" data-id="element-40">⭐️ 4.93/5</span>
          <span className="flex items-center gap-2" data-id="element-41">🩷 +10,000 Clientas</span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="space-y-6 text-left max-w-3xl font-inter text-gray-300 text-base sm:text-lg leading-relaxed" data-id="element-42">
          <p data-id="element-43">
            Mi don no vino de un aula. Vino de la peor noche de mi vida. Tenía
            19 años cuando todo se derrumbó — mi relación, mi salud, mi sentido
            de quién era. Pasé meses sin poder dormir, sin poder comer, sin
            poder sentir nada más que un vacío profundo.
          </p>
          <p data-id="element-44">
            Una noche, en mi momento más oscuro, algo cambió. Sentí una energía
            que no puedo explicar con palabras. Fue como si el universo me
            susurrara que había algo más grande esperándome. Desde ese momento,
            dediqué mi vida a entender esa conexión.
          </p>
          <p data-id="element-45">
            Estudié con maestros espirituales en tres continentes. Practiqué
            durante años antes de aceptar mi primer cliente. Y cuando finalmente
            lo hice, supe que esto era exactamente para lo que nací.
          </p>
          <p data-id="element-46">
            Hoy, más de 10 años después, he ayudado a más de 10,000 personas a
            encontrar la claridad que yo una vez desesperadamente necesité. Cada
            pedido que recibo me recuerda por qué hago esto. No es un trabajo.
            Es mi propósito.
          </p>
        </motion.div>
      </div>
    </section>;
}